import { Component, Input, Output, EventEmitter } from '@angular/core';

export interface User {
    id: string | number;
    name: string;
    email: string;
    avatar?: string;
    picture?: string;
}

@Component({
    selector: 'app-user-chip',
    templateUrl: './user-chip.component.html',
    styleUrls: ['./user-chip.component.scss'],
})
export class UserChipComponent {
    @Input() user!: User;
    @Input() showRemove: boolean = false;
    @Output() remove = new EventEmitter<User>();

    getUserAvatarUrl(): string {
        return this.user?.picture || this.user?.avatar || `https://www.pphfoundation.ca/wp-content/uploads/2018/05/default-avatar.png`;
    }

    onRemoveClick(): void {
        this.remove.emit(this.user);
    }
}
